import modal from './modal'
export class SolicitudAviso {
    constructor() {
        let btnSolicitudAviso = document.querySelector("[data-solicitud-aviso]");

        if (btnSolicitudAviso) {
            let ventana = modal();
            btnSolicitudAviso.addEventListener("click", (e) => {
                let slug = e.target.getAttribute("data-solicitud-aviso");
                let url = "/solicitud-aviso/"+slug;
                let self = this;
                NProgress.start();
                axios.get(url)
                    .then(function (response) {
                        ventana.open({content: response.data});
                        let formulario = document.querySelector(".modal-solicitud form");
                        if (formulario) {
                            formulario.addEventListener("submit", self.submit.bind(self));
                        }
                        let btnCerrar = document.querySelector(".modal-solicitud [data-dismiss='modal']");
                        if (btnCerrar) {
                            btnCerrar.addEventListener("click", (e) => {
                                ventana.close();
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log("-> error", error);
                    })
                    .finally(function () {
                        NProgress.done();
                    });
            });
        }
    }

    submit(e) {
        e.preventDefault();
        let formulario = e.target;
        let url = formulario.getAttribute("action")+"?v="+(new Date().getTime());
        let formData = new FormData(formulario);
        formData.append("acepto", "si");
        let errores = formulario.querySelectorAll(".modal-solicitud__error");
        for (let i = 0; i < errores.length; i++) {
            errores[i].remove();
        }
        NProgress.start();
        axios.post(url, formData)
            .then(function (response) {
                if (response.data.status === true) {
                    formulario.innerHTML = "<span class='modal-solicitud__ok'>"+response.data.message+"</span>";
                } else {
                    console.log("-> response.data", response.data);
                    if (response.data.errors) {
                        let errores = response.data.errors;
                        for (let campo in errores) {
                            let listaErrores = errores[campo];
                            let input = formulario.querySelector("[name='"+campo+"']");
                            if (input) {
                                for (let i = 0; i < listaErrores.length; i++) {
                                    let error = listaErrores[i];
                                    input.insertAdjacentHTML("afterend", "<span class='modal-solicitud__error'>"+error+"</span>");
                                }
                            }
                        }
                    } else {
                        formulario.innerHTML = "<span class='modal-solicitud__error'>"+response.data.message+"</span>";
                    }
                }
            })
            .catch(function (error) {
                console.log("-> error", error);
            })
            .finally(function () {
                NProgress.done();
            });

    }
}
